import DialogComponent from "components/Dialog";
//import DentalFormula from "components/DentalFormulaMini";

export default class DoseDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            info: false,
            studyTitle: false,
            patientAge: false,
            teeth: [],
            title: "",
            value: null
        };

        this.titleItems = [
            { id: 1, name: "Прицельный снимок" },
            { id: 2, name: "Панорамный снимок" },
            { id: 3, name: "КТ" },
        ];

        this.ageItems = [
            { id: 1, name: "Взрослый" },
            { id: 2, name: "Ребенок" },
        ];
    }

    title = "client.dose";

    show(info, hideCb) {
        this.state.info = info;
        this.hidCb = hideCb;
        super.show();
    }

    onShow() {
    }

    /*save() {
        const { studyTitle, patientAge, teeth } = this.state;

        if (studyTitle && this.fieldValue.value) {
            const value = {
                clientAge: this.ageItems[patientAge - 1].name,
                comment: this.fieldComment.value + "",
                researchArea: JSON.stringify(teeth),
                value: this.fieldValue.value + "",
            };

            const info = {
                title: this.titleItems[studyTitle - 1].name,
                value: JSON.stringify(value)
            };

            if (this.hidCb?.apply)
                this.hidCb(info);

            this.hide();
        } else {
            console.log("Ошибка поле не заполнено");
        }
    }*/

    save() {
        const { title, value } = this.state;

        if (title && value) {
            const info = {
                title,
                value
            };

            if (this.hidCb?.apply)
                this.hidCb(info);

            this.hide();
        } else {
            console.log("Ошибка поле не заполнено");
        }
    }

    changeTeethState(teeth) {
        this.setState({ teeth });
    }

    /*renderContent() {
        const { studyTitle, patientAge, info } = this.state;

        return (
            <div className="content flex col gap16">
                <div>{this.insertRowInfo("client.valueDose", "")}</div>
                <div className="flex gap16 col">
                    <div className="flex gap16">
                        {this.insertSelect({
                            ref: el => this.studyTitle = el,
                            itemStyle: "flex1",
                            label: "Название исследования",
                            placeHolder: "main.notIndicated",
                            translate: true,
                            required: true,
                            showLeftIcon: false,
                            items: this.titleItems,
                            value: studyTitle,
                            onChange: this.changeState.bind(this, "studyTitle")
                        })}
                        <div className="flex gap8">
                            {this.insertInput({
                                ref: el => this.fieldValue = el,
                                label: "client.fieldValue",
                                placeHolder: "0.0034",
                                value: info.title,
                            })}
                            <div className="flex endV">
                                <div>
                                    {this.insertButtonIcon({
                                        name: "edit"
                                    })}
                                </div>

                            </div>
                        </div>

                    </div>
                    <div style={{ width: "180px" }}>
                        {this.insertSelect({
                            ref: el => this.patientAge = el,
                            itemStyle: "flex1",
                            label: "Возраст пациента",
                            placeHolder: "main.notIndicated",
                            translate: true,
                            required: true,
                            showLeftIcon: false,
                            items: this.ageItems,
                            value: patientAge,
                            onChange: this.changeState.bind(this, "patientAge")
                        })}
                    </div>
                    <div className="flex">
                        {this.insertInput({
                            ref: el => this.fieldComment = el,
                            itemStyle: "flex1",
                            label: "Комментарий",
                            placeHolder: "Ваш комментарий...",
                            value: info.value,
                        })}
                    </div>
                </div>
                {studyTitle === 1 && <DentalFormula onChangeTeeth={this.changeTeethState.bind(this)} />}
            </div>
        );
    }*/

    renderContent() {
        const { title, value } = this.state;

        return (
            <div className="content flex col gap16">
                <div>{this.insertRowInfo("client.valueDose", "")}</div>
                <div className="flex gap16">
                    {this.insertInput({
                        ref: el => this.fieldComment = el,
                        itemStyle: "flex1",
                        placeHolder: "Значение поля...",
                        value: title,
                        onChange: this.changeState.bind(this, "title")
                    })}
                    {this.insertInput({
                        ref: el => this.fieldValue = el,
                        placeHolder: "0",
                        value,
                        onChange: this.changeState.bind(this, "value")
                    })}
                </div>
            </div>
        );
    }
}

